import React from "react";

export function PageContent({ children }: { children: React.ReactNode }) {
  return (
    <div className="tw-flex tw-h-full tw-flex-grow tw-flex-col tw-overflow-auto tw-bg-neutral-25 tw-px-6 tw-pb-10 tw-pt-6">
      {children}
    </div>
  );
}
